import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import globalConfig from '../../configs/globalConfigs';
import { mapDashboardDynamic } from '../../utils/entity-utils';

/* ----------------------------------------------------------------
      SLICE (ACTIONS/REDUCERS)
---------------------------------------------------------------- */

const initialState = {
  loading: false,
  error: null,
  data: {},
};

const dashboardDynamicSlice = createSlice({
  name: 'dashboardDynamic',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getAllDynamicDashboard.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllDynamicDashboard.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.data;
    });
    builder.addCase(getAllDynamicDashboard.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default dashboardDynamicSlice.reducer;

/* ----------------------------------------------------------------
      MIDDLEWARE - API CALLS
---------------------------------------------------------------- */
export const getAllDynamicDashboard = createAsyncThunk('dashboardDynamic/fetchDashboardDynamic', async (initialPost) => {
  const { region, pathway } = initialPost;
  const result = await axios.post(globalConfig.API_DASHBOARD_DYNAMIC, {
    region,
    scenario: pathway,
  });

  return { data: mapDashboardDynamic(result.data) };
});
